export const LS_KEYS = {
  AUTH_TOKEN: 'auth_token',
  LANGUAGE: 'language',
};
